import { render, staticRenderFns } from "./PanelCustomerFreight.vue?vue&type=template&id=4b7f243e&scoped=true&"
import script from "./PanelCustomerFreight.vue?vue&type=script&lang=ts&"
export * from "./PanelCustomerFreight.vue?vue&type=script&lang=ts&"
import style0 from "./PanelCustomerFreight.vue?vue&type=style&index=0&id=4b7f243e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f243e",
  null
  
)

export default component.exports